module.exports = __webpack_public_path__ + "components/country-flag/static/zw-926d53ef6038777950242d030942d2d3.svg";